"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        pattern: 'This field  does not match any pattern',
        required: 'This field is required',
        number: 'This field is not a number',
        integer: 'This field is not an integer number',
        url: 'This field is a invalid url',
        email: 'This field is not a email format',
        ipv6: 'This field is not a ipv6 format',
        ipv4: 'This field is not a ipv4 format',
        idcard: 'This field is not an idcard format',
        taodomain: 'This field is not a taobao domain format',
        qq: 'This field is not a qq number format',
        phone: 'This field is not a phone number format',
        money: 'This field is not a currency format',
        zh: 'This field is not a chinese string',
        date: 'This field is not a valid date format',
        zip: 'This field is not a zip format',
        len: 'The length or number of entries must be {{len}}',
        min: 'The length or number of entries must be at least {{min}}',
        maximum: 'The value cannot be greater than {{maximum}}',
        exclusiveMaximum: 'The value must be less than {{exclusiveMaximum}}',
        minimum: 'The value cannot be less than {{minimum}}',
        exclusiveMinimum: 'The value must be greater than {{exclusiveMinimum}}',
        max: 'The length or number of entries must be at most {{max}}',
        whitespace: 'This field cannot be blank string.'
    },
    zh: {
        pattern: '该字段不是一个合法的字段',
        required: '该字段是必填字段',
        number: '该字段不是合法的数字',
        integer: '该字段不是合法的整型数字',
        url: '该字段不是合法的url',
        email: '该字段不是合法的邮箱格式',
        ipv6: '该字段不是合法的ipv6格式',
        ipv4: '该字段不是合法的ipv4格式',
        idcard: '该字段不是合法的身份证格式',
        taodomain: '该字段不符合淘系域名规则',
        qq: '该字段不符合QQ号格式',
        phone: '该字段不是有效的手机号',
        money: '该字段不是有效货币格式',
        zh: '该字段不是合法的中文字符串',
        date: '该字段不是合法的日期格式',
        zip: '该字段不是合法的邮编格式',
        len: '长度或条目数必须为{{len}}',
        min: '长度或条目数不能小于{{min}}',
        max: '长度或条目数不能大于{{max}}',
        maximum: '数值不能大于{{maximum}}',
        exclusiveMaximum: '数值必须小于{{exclusiveMaximum}}',
        minimum: '数值不能小于{{minimum}}',
        exclusiveMinimum: '数值必须大于{{exclusiveMinimum}}',
        whitespace: '不能为纯空白字符串'
    },
    'en-US': {
        pattern: 'This field  does not match any pattern',
        required: 'This field is required',
        number: 'This field is not a number',
        integer: 'This field is not an integer number',
        url: 'This field is a invalid url',
        email: 'This field is not a email format',
        ipv6: 'This field is not a ipv6 format',
        ipv4: 'This field is not a ipv4 format',
        idcard: 'This field is not an idcard format',
        taodomain: 'This field is not a taobao domain format',
        qq: 'This field is not a qq number format',
        phone: 'This field is not a phone number format',
        money: 'This field is not a currency format',
        zh: 'This field is not a chinese string',
        date: 'This field is not a valid date format',
        zip: 'This field is not a zip format',
        len: 'The length or number of entries must be {{len}}',
        min: 'The length or number of entries must be at least {{min}}',
        maximum: 'The value cannot be greater than {{maximum}}',
        exclusiveMaximum: 'The value must be less than {{exclusiveMaximum}}',
        minimum: 'The value cannot be less than {{minimum}}',
        exclusiveMinimum: 'The value must be greater than {{exclusiveMinimum}}',
        max: 'The length or number of entries must be at most {{max}}',
        whitespace: 'This field cannot be blank string.'
    },
    'zh-CN': {
        pattern: '该字段不是一个合法的字段',
        required: '该字段是必填字段',
        number: '该字段不是合法的数字',
        integer: '该字段不是合法的整型数字',
        url: '该字段不是合法的url',
        email: '该字段不是合法的邮箱格式',
        ipv6: '该字段不是合法的ipv6格式',
        ipv4: '该字段不是合法的ipv4格式',
        idcard: '该字段不是合法的身份证格式',
        taodomain: '该字段不符合淘系域名规则',
        qq: '该字段不符合QQ号格式',
        phone: '该字段不是有效的手机号',
        money: '该字段不是有效货币格式',
        zh: '该字段不是合法的中文字符串',
        date: '该字段不是合法的日期格式',
        zip: '该字段不是合法的邮编格式',
        len: '长度或条目数必须为{{len}}',
        min: '长度或条目数不能小于{{min}}',
        max: '长度或条目数不能大于{{max}}',
        maximum: '数值不能大于{{maximum}}',
        exclusiveMaximum: '数值必须小于{{exclusiveMaximum}}',
        minimum: '数值不能小于{{minimum}}',
        exclusiveMinimum: '数值必须大于{{exclusiveMinimum}}',
        whitespace: '不能为纯空白字符串'
    },
    'zh-TW': {
        pattern: '該字段不是一個合法的字段',
        required: '該字段是必填字段',
        number: '該字段不是合法的數字',
        integer: '該字段不是合法的整型數字',
        url: '該字段不是合法的url',
        email: '該字段不是合法的郵箱格式',
        ipv6: '該字段不是合法的ipv6格式',
        ipv4: '該字段不是合法的ipv4格式',
        idcard: '該字段不是合法的身份證格式',
        taodomain: '該字段不符合淘系域名規則',
        qq: '該字段不符合QQ號格式',
        phone: '該字段不是有效的手機號',
        money: '該字段不是有效貨幣格式',
        zh: '該字段不是合法的中文字符串',
        date: '該字段不是合法的日期格式',
        zip: '該字段不是合法的郵編格式',
        len: '長度或條目數必須為{{len}}',
        min: '長度或條目數不能小於{{min}}',
        max: '長度或條目數不能大於{{max}}',
        maximum: '數值不能大於{{maximum}}',
        exclusiveMaximum: '數值必須小於{{exclusiveMaximum}}',
        minimum: '數值不能小於{{minimum}}',
        exclusiveMinimum: '數值必須大於{{exclusiveMinimum}}',
        whitespace: '不能為純空白字符串'
    }
};
